export const FRAUD_ALERTS_KEY = "PROPERTY_SHIELD_FRAUD_ALERTS";
export const MONITORED_PROPERTIES_KEY = "PROPERTY_SHIELD_MONITORED_PROPERTIES";
export const PROPERTY_SHIELD_INTEGRATION_KEY = "PROPERTY_SHIELD_INTEGRATION";
export const MONITORING_STATUS_KEY = "PROPERTY_SHIELD_MONITORING_STATUS";
